import { produce } from 'immer';
import { seo } from '../../../constants/actionTypes';

const initState = {};

export default produce((draft, action) => {
  switch (action.type) {
    case seo.FETCH_DRAMA_SEO_INFO: {
      draft[action.payload.id] = action.payload.data;
      break;
    }
  }
}, initState);
